module.exports = __webpack_public_path__ + "img/film.0abe31c.png";